// removed by extract-text-webpack-plugin
module.exports = {"moreLessButton":"ToolDescriptions__moreLessButton--NMLli","toolDescriptionContainer":"ToolDescriptions__toolDescriptionContainer--r4VWn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ToolDescriptions/ToolDescriptions.css
// module id = hf6v
// module chunks = 47